import { compose } from 'recompose';

import InfoBlockTotalView from './InfoBlockTotalView';

export default compose()(InfoBlockTotalView);
